import React from 'react';
import styled from 'styled-components';

const Loader = styled.div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transition: opacity .5s;
    opacity: 1;
    ${p => p.isTransparent ? `
        opacity: 0;
    ` : ''}
    && div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }
    && div:nth-child(1) {
        animation-delay: -0.45s;
        }
    && div:nth-child(2) {
        animation-delay: -0.3s;
        }
    && div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

`

const ActivityIndicator = () => {
    return (
        <Loader><div></div><div></div><div></div><div></div></Loader>
    );
};

export default ActivityIndicator;